<table class="table">
  @for (invoice of invoices; track invoice) {
    <tr lines="none" [class]="invoice.expanded ? 'expanded' : ''">
      <!--<div class="itemwrapper">
      <div class="itemtop">-->
        <td class="chargedate">
          <mat-icon class="expandcollapse" (click)="expandCollapse(invoice)">
            {{ invoice.expanded ? 'arrow_drop_down' : 'arrow_right' }}
          </mat-icon>
          <span>Initiated {{ invoice.date | date : 'MMM d, y, h:mm:ss a' }}</span>
        </td>
        <td text-wrap class="chargedescription" (click)="openInvoice(invoice.url)">{{ invoice.info }}</td>
        <td class="chargeamount">{{ invoice.amount | currency }}</td>
        <td class="chargedescription">
          {{ invoice.status }}
          @if ((invoice.carriedForwardAmount != null && invoice.carriedForwardAmount > 0)) {
            <div>{{ invoice.carriedForwardAmount | currency }} was carried forward to a future invoice. No payment was collected for this invoice.</div>
          }
        </td>
      <!--</div>-->
      @if (invoice.expanded) {
        <div class="detailswrapper">
          @if (invoice.invoiceNumber) {
            <span>Invoice {{ invoice.invoiceNumber }}</span>
          }
          @if (!((invoice.carriedForwardAmount != null && invoice.carriedForwardAmount > 0))) {
            <span>{{ invoice.details.paymentType }}</span>
          }
          @if (invoice.paidAt && !((invoice.carriedForwardAmount != null && invoice.carriedForwardAmount > 0))) {
            <span>Paid {{ invoice.paidAt * 1000 | date : 'MMM d, y, h:mm:ss a' }}</span>
          }
          <section class="recipient-allocations" aria-label="Recipient allocations">
            @if (invoice.funding) {
              <strong>Recipient allocations</strong>
              @for (recipient of invoice.funding.recipients; track recipient) {
                <div class="recipient">
                  <span>{{ recipient.email || 'Recipient email unavailable' }}</span>
                  <span>{{ recipient.amount | currency }}</span>
                  <span>{{ settlementLabel(recipient.settlementAction) }}@if (recipient.settledAt) {
                    · {{ recipient.settledAt | date : 'MMM d, y, h:mm:ss a' }}
                  }</span>
                </div>
              }
            } @else {
              Recipient allocation details unavailable
            }
          </section>
          <div class="details-container">
            @for (line of invoice?.details?.fee; track line) {
              <div class="details">
                <div class="description">{{ line.description }}</div>
                <div class="amount">{{ $safeNavigationMigration(line?.amount) | currency }}</div>
                <div class="diff">{{ $safeNavigationMigration(line?.diff) | currency }}</div>
              </div>
            }
          </div>
        </div>
      }
    <!--</div>-->
  </tr>
}
</table>
